import React, { useState, useEffect } from "react";
import { Select } from "antd";

const { Option } = Select;

const Dropdown = ({
  index,
  value,
  options,
  onChange,
  showSearch = false,
  data,
  ...props
}) => {
  const [open, setOpen] = useState(false);
  const isNaics = !!data?.naicsInput;

  const filterOption = (input, option) => {
    if (!option || !option.label || !option.value) return false;
    const label = option.label.toString().toLowerCase();
    const val = option.value.toString().toLowerCase();
    const inputValue = input.toLowerCase();
    return isNaics
      ? label.includes(inputValue) || val.includes(inputValue)
      : label.includes(inputValue);
  };

  return (
    <Select
      defaultValue={value}
      value={value}
      open={open}
      onDropdownVisibleChange={(visible) => {
        // Ignore close events when the browser window itself loses focus
        if (!visible && typeof document !== "undefined" && !document.hasFocus()) {
          return;
        }
        setOpen(visible);
      }}
      style={{ width: "100%" }}
      onChange={onChange}
      showSearch={showSearch}
      getPopupContainer={(trigger) => trigger.parentElement}
      className="dropdown"
      filterOption={filterOption}
      {...props}
    >
      {props.mode === "undefined" && <Option value="none">None</Option>}
      {options.map((option, i) => (
        <Option
          key={`form-question-${index}-option-${i}`}
          value={option.value}
          label={option.label}
          disabled={option.indicator}
          className={option.indicator ? "select-option-indicator" : ""}
          title={typeof option.title === "string" ? option.title : ""}
        >
          {isNaics ? `${option.label} - ${option.value}` : option.value}
        </Option>
      ))}
    </Select>
  );
};

export default Dropdown;
